import React from "react";
import { useContext } from "react";
import DropDownMenu from "./dropdownMenu";
import { Typography } from "@mui/material";
import StateContext from "../StateContext";
import { RequestFactory } from "../libs/services";
import DndMenu from "./dndMenu";
import ShuffleIcon from "@mui/icons-material/Shuffle";
import PersonIcon from "@mui/icons-material/Person";

export const Playlist = ({
  numberOfUserConnected,
}: {
  numberOfUserConnected: number;
}) => {
  const [name, setName] = React.useState("");
  const context = useContext(StateContext);

  const { listPlaylist, currentPlaylist } = context;

  const handleCreatePlaylist = () => {
    RequestFactory.playlist.create(name);
  };

  const handleShufflePlaylist = () => {
    currentPlaylist &&
      RequestFactory.currentPlaylist.change(currentPlaylist.id, true);
  };

  const handleChoosePlaylist = (value: string) => {
    const playlist = listPlaylist.find((p) => p.name === value);
    if (playlist) {
      RequestFactory.currentPlaylist.change(playlist.id);
    }
  };

  return (
    <div className="playlist-container">
      <div className="playlist-header">
        <Typography variant="h1">{currentPlaylist?.name ?? "-"}</Typography>
        <div style={{ display: "flex" }}>
          {Array.from({ length: numberOfUserConnected }, (_, i) => i + 1).map(
            (i) => (
              <PersonIcon key={i} />
            )
          )}
        </div>
        <div
          className="playlist-header-icons"
          style={{ display: "flex", alignItems: "center" }}
        >
          <DropDownMenu
            options={listPlaylist.map((p) => p.name)}
            setPlaylist={handleChoosePlaylist}
          />
          <ShuffleIcon onClick={() => handleShufflePlaylist()} />
        </div>
      </div>
      {/* <div>
        <TextField
          label="Nom de la playlist"
          variant="filled"
          onChange={(v) => setName(v.target.value)}
        />
        <Button variant="contained" onClick={() => handleCreatePlaylist()}>
          Créer la playlist
        </Button>
      </div> */}
      {currentPlaylist?.musics && <DndMenu />}
    </div>
  );
};
